import React, { Component } from "react";
import "../../App.css";
import { getKiteToken, updateKiteToken, postCoinToken, postConsoleToken } from "../../Api/Http";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { executeFunction } from "../../Utils/utils";

class Targets extends Component {
    async componentDidMount() {
        let isTokenInputBoxDisabled = true;
        let getKiteTokenResp = await getKiteToken();
        const onClickOfEditButtonOfToken = () => {
            isTokenInputBoxDisabled = false;
            this.setState({ isTokenInputBoxDisabled: isTokenInputBoxDisabled });
        };

        const onClickOfTickButtonOfToken = async () => {
            const updatedValue = document.getElementById("auth_token_input_box").value;
            if (getKiteTokenResp !== updatedValue) {
                await executeFunction({
                    reference: updateKiteToken,
                    body: {
                        token: updatedValue,
                    },
                });
                this.setState({ token: updatedValue });
            }
            isTokenInputBoxDisabled = true;
            this.setState({ isTokenInputBoxDisabled: isTokenInputBoxDisabled });
        };

        const onSubmitCoinCurl = async () => {
            const curl = document.getElementById("auth_coin_curl_box").value;
            if (curl) {
                await executeFunction({ reference: postCoinToken, body: { curl } });
            }
        };

        const onSubmitConsoleCurl = async () => {
            const curl = document.getElementById("auth_console_curl_box").value;
            if (curl) {
                await executeFunction({ reference: postConsoleToken, body: { curl } });
            }
        };
        this.setState({ token: getKiteTokenResp });
        this.setState({ isTokenInputBoxDisabled: isTokenInputBoxDisabled });
        this.setState({ onClickOfEditButtonOfToken: onClickOfEditButtonOfToken });
        this.setState({ onClickOfTickButtonOfToken: onClickOfTickButtonOfToken });
        this.setState({ onSubmitCoinCurl, onSubmitConsoleCurl });
    }
    render() {
        return (
            <div>
                <div>
                    <header>
                        <h1>Token </h1>
                        <span>
                            <input
                                id="auth_token_input_box"
                                className="auth-token-input-box"
                                disabled={this.state && this.state.isTokenInputBoxDisabled}
                                defaultValue={this.state && this.state.token}
                            ></input>
                            <span>
                                {this.state && this.state.isTokenInputBoxDisabled && (
                                    <button onClick={() => this.state.onClickOfEditButtonOfToken({})}>&#x270E;</button>
                                )}
                                {!(this.state && this.state.isTokenInputBoxDisabled) && (
                                    <button onClick={() => this.state.onClickOfTickButtonOfToken({})}>&#x2714;</button>
                                )}
                            </span>
                        </span>
                    </header>
                </div>
                <div>
                    <header>
                        <h1>Coin – paste curl</h1>
                        <textarea
                            id="auth_coin_curl_box"
                            className="auth-token-input-box"
                            rows={4}
                            placeholder="Paste curl here"
                        />
                        <button onClick={() => this.state && this.state.onSubmitCoinCurl()}>Submit</button>
                    </header>
                </div>
                <div>
                    <header>
                        <h1>Console – paste curl</h1>
                        <textarea
                            id="auth_console_curl_box"
                            className="auth-token-input-box"
                            rows={4}
                            placeholder="Paste curl here"
                        />
                        <button onClick={() => this.state && this.state.onSubmitConsoleCurl()}>Submit</button>
                    </header>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default Targets;
